import { render, staticRenderFns } from "./messageTemplate.vue?vue&type=template&id=5d954197&"
import script from "./messageTemplate.vue?vue&type=script&lang=js&"
export * from "./messageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./messageTemplate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports